<template>
	<v-dialog v-model="setdialog.dialog" :width="nowWidth < 600 ? '90%' : '500px'" persistent content-class="mx-2 reservedayViewport">
		<div class="exitVisitBtn" :style="`max-width:${nowWidth < 600 ? '90%' : '500px'};`" v-show="!setdialog.step2 && !setdialog.step3">
			<v-btn icon @click="exitSurvey" v-show="$route.name !== 'createwaiting'">
				<v-icon size="35px" color="white">
					mdi-close-circle
				</v-icon>
			</v-btn>
		</div>
		<v-card class="dialogDays" v-if="setdialog.step1">
			<div class="dialog-content">
				<v-layout justify-center v-if="step1">
					<div class="vieport_headTxt">
						방문에 앞서 원활한 접수를 위해 설문을 부탁 드립니다.
					</div>
				</v-layout>
				<!-- 설문 -->
				<view-portReserve :reservedaysData="reservedaysData" :step1="step1" />
				<!-- 설문 단계 bottom 버튼 -->
				<div class="bottom">
					<v-layout justify-center style="max-width:365px;">
						<!-- 설문 페이지 버튼 -->
						<v-flex xs6 class="pr-2" v-if="step1">
							<btn
								:btn_txt="'예약하기'"
								:style="`background-color:${$store.state.PointColor7}; color:${$store.state.PointColor8}`"
								class="ml-2"
								:btn="saveBtn"
								@click="toDatePicker"
							></btn>
						</v-flex>
						<!-- 시간 선택 페이집 -->
						<v-flex v-else-if="!step1" xs6 class="pr-2">
							<btn
								btn_txt="확인 및 예약하기"
								:style="`background-color:${$store.state.PointColor7}; color:${$store.state.PointColor8}`"
								class="ml-2"
								:btn="saveBtn"
								@click="
									() => {
										$store.state.loading = true
										maxCountCheck('create')
									}
								"
							></btn>
						</v-flex>

						<v-flex xs6 class="pl-2">
							<btn btn_txt="예약취소" :btn="closeBtn" @click="clickCancel" :style="`background-color:${$store.state.PointColor7};`"> </btn>
						</v-flex>
					</v-layout>
				</div>
			</div>
		</v-card>
		<!-- 기존 예약 확인 -->
		<v-card class="dialogDays" v-if="setdialog.step2">
			<div class="dialog-content1">
				<div class="infoCard">
					<div style="border-bottom: 3px dashed #E8E8E8">
						<v-layout justify-center>
							<div class="infoBackground" :style="`background-color:${$store.state.PointColor7}`">
								<v-icon size="40px" color="white">mdi-check </v-icon>
							</div>
						</v-layout>
						<p class="surveyNameres">
							[{{ $store.state.reserveUserData.name ? $store.state.reserveUserData.name : setdialog.inputUserData.name }}]고객님 방문정보를
							확인하세요.
						</p>
					</div>
					<div>
						<div class="infoText" v-if="$store.state.reserveUserData.name">
							고객명
							<span class="infoTextValue">{{ $store.state.reserveUserData.name }} </span>
						</div>
						<div class="infoText" v-else>
							고객명
							<span class="infoTextValue">{{ setdialog.inputUserData.name }} </span>
						</div>
						<div class="infoText" v-if="$store.state.reserveUserData.reserveUpdateDate !== ''">
							{{ '신청일시' }}

							<span class="infoTextValue">{{ $store.state.reserveUserData.reserveUpdateDate | moment('YYYY-MM-DD HH:mm') }}</span>
						</div>
						<div class="infoText" v-else>
							{{ '신청일시' }}
							<span class="infoTextValue">{{ new Date() | moment('YYYY-MM-DD HH:mm') }}</span>
						</div>
						<div class="infoText" v-if="$store.state.reserveUserData.reservedDate">
							예약일시<span class="infoTextValue" style="color:#4C428C;">
								{{
									$moment($store.state.reserveUserData.reservedDate)
										.subtract(9, 'hours')
										.format('YYYY-MM-DD HH:mm')
								}}
							</span>
						</div>
					</div>
				</div>
				<div class="springNote"></div>
				<p class="lastInfoRes">
					*방문확인을 위한 알림톡이 발송되었습니다.
				</p>
				<p class="lastInfoRes">
					알림톡을 통해 예약 변경 및 취소가 가능합니다.
				</p>
				<!-- bottom -->
				<div class="bottom2 mt-6">
					<v-layout flex-wrap>
						<v-flex xs12 class="mb-4">
							<btn
								btn_txt="확인"
								:style="`background-color:${$store.state.PointColor7}; color:${$store.state.PointColor8}; border-radius: 0px; `"
								:btn="doneBtn"
								@click="clickdoneBtn"
							></btn>
						</v-flex>
						<v-flex xs6 class="pr-2">
							<btn
								btn_txt="예약변경"
								:style="`background-color:${$store.state.PointColor7}; color:${$store.state.PointColor8}; border-radius: 0px;`"
								:btn="reserveChange"
								@click="clickChangeBtn"
							></btn>
						</v-flex>
						<v-flex xs6 class="pl-2">
							<btn
								btn_txt="예약취소"
								:style="`background-color:${$store.state.PointColor7}; border-radius: 0px;`"
								:btn="reseveCancel"
								@click="clickreseveCancel"
							></btn>
						</v-flex>
					</v-layout>
				</div>
			</div>
		</v-card>
		<!-- 예약 완료 화면 -->
		<v-card class="dialogDays" v-if="setdialog.step3">
			<div class="dialog-content1">
				<div class="infoCard">
					<div style="border-bottom: 3px dashed #E8E8E8">
						<v-layout justify-center>
							<div class="infoBackground" :style="`background-color:${$store.state.PointColor7}`">
								<v-icon size="40px" color="white">mdi-check </v-icon>
							</div>
						</v-layout>
						<p class="surveyNameres">
							[{{ $store.state.reserveUserData.name ? $store.state.reserveUserData.name : setdialog.inputUserData.name }}]고객님<br />
							고객님의 방문 정보를 확인하세요.
						</p>
					</div>
				</div>
				<div class="springNote"></div>
				<p class="lastInfoRes">
					예약정보 확인을 위한 알림톡이 발송되었습니다.
				</p>
				<p class="lastInfoRes">
					알림톡을 통해 예약 변경 및 취소가 가능합니다.
				</p>
				<!-- bottom -->
				<div class="bottom2 mt-6">
					<v-layout flex-wrap>
						<v-flex xs12 class="mb-4">
							<v-layout style="width: 100%;">
								<btn
									btn_txt="확인"
									:style="`background-color:${$store.state.PointColor7}; color:${$store.state.PointColor8}; border-radius: 0px;`"
									:btn="doneBtn"
									@click="() => done()"
								></btn>
							</v-layout>
						</v-flex>

						<v-flex xs12>
							<btn
								btn_txt="예약취소"
								:style="`background-color:${$store.state.PointColor7}; border-radius: 0px;`"
								:btn="reseveCancel"
								@click="clickreseveCancel"
							></btn>
						</v-flex>
					</v-layout>
				</div>
			</div>
		</v-card>
		<alertModal5 :setdialog="alertModal" />
		<alertModal5 :setdialog="alertModal2" />
	</v-dialog>
</template>

<script>
import { alertModal5, btn, viewPortReserve } from '@/components/index'
import location1 from '../../utils/location1'
import location2 from '../../utils/location2'
export default {
	components: {
		btn,
		viewPortReserve,
		alertModal5,
	},
	props: {
		reservedaysData: Object,
		setdialog: Object,
		title: String,
		tab: Object,
		// noInputBox: Boolean,
	},
	data() {
		return {
			endBtn: false,
			previewEventTalk: {
				dialog: false,
				modalIcon: 'success',
				title: '',
				content: '',
			},
			imgFiles: [],
			giftBox: {
				dialog: false,
				color: 'black',
				titleColor: 'white',
				title: 'test',
				product: '',
				winnerMessage: '',
				joinMessage: '',
			},
			isSubmitting: false, // 중복 클릭 방지 플래그
			recentPhone: '', // 연속 waiting 생성 방지 data
			step1: true,
			// --- date picker --
			picker: { date: '', allowedDates: '2021-5-30' },
			// --- 시간 선택 버튼 ---
			timeData: [],
			selectedTime: '',
			// --- 버튼 ---
			cancelBtn: {
				class: 'cancel',
			},
			saveBtn: {
				class: 'customBtn',
				width: '100%',
			},
			closeBtn: {
				block: true,
				large: true,
				class: 'selectBtn',
			},
			doneBtn: {
				class: 'customBtn',
				dark: false,
				block: true,
				disabled: true,
			},
			reseveCancel: {
				class: 'selectBtn',
				block: true,
			},
			reserveChange: {
				class: 'customBtn',
				dark: true,
				block: true,
			},
			alertModal: {
				dialog: false,
				text: '표시된 필수 입력 부분을 모두 입력해주세요.',
				reddot: true,
			},
			alertModal2: {
				dialog: false,
				text: '',
			},
			okaySetDialog: {
				dialog: false,
				text: '',
				title: '완료',
			}, // 캠페인 완료 후 나오는 모달
			// --- 캠페인 명 ---
			campaignName: 'TEST CAMPAIGN MODELHOUSE',
			reserveChangeOn: false,
			message: '',
			messageData1: {}, // create / update 알림톡 데이터
			messageData2: {}, // delete 알림톡 데이터
			messageData3: {},
			messageData4: {}, // 내가 받을 알림톡 데이터
			messageData5: {}, // 내가 받을 알림톡 취소시 데이터
			messageData6: {}, // 현장 방문등록
			length: {},

			// 오늘 대기 번호
			waitNum: '',
			/// 대기자 수
			waitLength: '',
			// 예약률
			percent: '',

			screenWidth: window.innerWidth,
		}
	},
	computed: {
		closeActive() {
			return this.$store.state.closeActive
		},
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	watch: {
		closeActive() {
			this.setdialog.dialog = false
		},
		setdialog: {
			deep: true,
			handler() {
				if (this.setdialog.step1) {
					this.clickChangeBtn()
				}
			},
		},
	},
	methods: {
		loc_firstSelect(val) {
			this.$store.state.searchsel_city2.items = location1[val].sort()
		},
		loc_twoSelect(val) {
			this.$store.state.searchsel_city3.items = location2[this.$store.state.searchsel_city1.value][val].sort()
		},
		done() {
			this.setdialog.dialog = false
			if (document.getElementById('refresh-visit')) document.getElementById('refresh-visit').click()
			else {
				window.open('about:blank', '_self').close()
				if (this.isMobile() !== 'desktop') {
					location.href = 'kakaotalk://inappbrowser/close'
				}
			}
		},
		shuffle(array) {
			return array.sort(() => Math.random() - 0.5)
		},
		randomItem(item) {
			return item[Math.floor(Math.random() * item.length)]
		},
		reserveusers(type) {
			const data = {
				// rsdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T' + this.$moment(new Date()).format('HH:mm:ss') + '.000Z',
				phone: this.$store.state.reserveusersData.phone,
				code: this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE,
			}
			this.$store
				.dispatch('reserveusers', data)
				.then(res => {
					this.$store.state.reserveusersData = res.data.reserveusers[0]
					this.$store.state.reserveuserId = res.data.reserveusers[0].id
					if (type !== 'create') {
						this.clickChangeBtn('re')
					}
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},
		changeTypeText(data) {
			if (data === 11) {
				return 'checkbox'
			} else if (data === 10 || data === 12) {
				return 'checkone'
			} else if (data === 20) {
				return 'textfiled'
			}
		},
		// 생성 / 수정시 알림톡
		creaetSendMessage() {
			let date = `${this.$store.state.picker.date} ${this.$store.state.selectedTime}`
			let url = `${location.protocol}//${location.hostname}/myQr/${
				this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE
			}/${this.$store.state.trackingCodeCode}`
			let reserveDayurl = `${location.protocol}//${location.hostname}/reserve_day/${
				this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE
			}`
			const now = new Date()
			const today = this.$moment(now).format('YYYY년 MM월 DD일 HH:mm')
			if (this.messageData1.message === undefined) {
				// 생성 / 수정시 알림톡 tpl_code가 없는 경우
				return
			} else {
				this.messageData1.message = this.messageData1.message.replace(/#{사업지명}/g, this.$store.state.reservedayData.title)
				this.messageData1.message = this.messageData1.message.replace(/#{고객명}/g, this.$store.state.reserveusersData.name)
				this.messageData1.message = this.messageData1.message.replace(/#{예약신청일시}/g, today)
				this.messageData1.message = this.messageData1.message.replace(/#{관람신청일시}/g, today)
				this.messageData1.message = this.messageData1.message.replace(/#{상담신청일시}/g, today)
				this.messageData1.message = this.messageData1.message.replace(/#{예약일시}/g, date)
				this.messageData1.message = this.messageData1.message.replace(/#{고객정보}/g, url)
				this.messageData1.message = this.messageData1.message.replace(/#{예약URL}/g, reserveDayurl)
				this.messageData1.message = this.messageData1.message.replace(/#{대표번호}/g, this.$store.state.reservedayData.callerNumber)
			}
			if (this.messageData1.button) {
				const buttonsData = JSON.parse(this.messageData1.button)
				buttonsData.forEach(element => {
					element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
					element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
					element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
					element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
					element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.$route.params.id)
					element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.$route.params.id)
					element.linkMo = element.linkMo.replace(/#{전화번호}/g, this.$store.state.reserveusersData.phone)
					element.linkPc = element.linkPc.replace(/#{전화번호}/g, this.$store.state.reserveusersData.phone)
					element.linkMo = element.linkMo.replace(
						/#{분양정보pdf}/g,
						this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
					)
					element.linkPc = element.linkPc.replace(
						/#{분양정보pdf}/g,
						this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
					)
					if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
						element.linkMo = element.linkMo.replace(
							/#{청약안내pdf}/g,
							this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
						)
						element.linkPc = element.linkPc.replace(
							/#{청약안내pdf}/g,
							this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
						)
					}
					element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
					element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
					element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
					element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
				})
				this.messageData1.button = JSON.stringify(buttonsData)
			}
			const data = {
				// 필수값

				code: this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE,
				sender: this.reservedaysData.callerNumber ? this.reservedaysData.callerNumber : process.env.VUE_APP_SENDER,
				senderkey: process.env.VUE_APP_SENDERKEY,
				tpl_code: this.messageData1.tplCode,
				receiver_1: this.$store.state.reserveusersData.phone,
				subject_1: this.messageData1.tplCodeStr,
				message_1: this.messageData1.message,
				recvname_1: this.$store.state.reserveusersData.name,
				failover: 'Y',
				fsubject_1: this.messageData1.tplCodeStr,
				fmessage_1: this.messageData1.message,
				button_1: this.messageData1.button ? this.messageData1.button : '[]',
				pay: this.reservedaysData.business?.id,
			}
			this.$store.dispatch('createSendMessage', data).then(() => {
				this.doneBtn.disabled = false
			})
		},

		// 예약취소시 알림톡
		deleteSendMessage() {
			const now = new Date()
			const today = this.$moment(now).format('YYYY년 MM월 DD일 HH:mm')
			let reserveDayurl = `${location.protocol}//${location.hostname}/reserve_day/${
				this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE
			}`
			console.log(this.messageData2)
			if (this.messageData2.message === undefined) {
				// 취소시 알림톡 tpl_code가 없는 경우
				return
			} else {
				this.messageData2.message = this.messageData2.message.replace(/#{사업지명}/g, this.$store.state.reservedayData.title)
				this.messageData2.message = this.messageData2.message.replace(/#{고객명}/g, this.$store.state.reserveusersData.name)
				this.messageData2.message = this.messageData2.message.replace(/#{예약취소일시}/g, today)
				this.messageData2.message = this.messageData2.message.replace(/#{예약URL}/g, reserveDayurl)
				this.messageData2.message = this.messageData2.message.replace(/#{대표번호}/g, this.$store.state.reservedayData.callerNumber)
			}
			if (this.messageData2.button) {
				const buttonsData = JSON.parse(this.messageData2.button)
				buttonsData.forEach(element => {
					if (element.linkMo) {
						element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
						element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
						element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
						element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
						element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.$route.params.id)
						element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.$route.params.id)
						element.linkMo = element.linkMo.replace(
							/#{분양정보pdf}/g,
							this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
						)
						element.linkPc = element.linkPc.replace(
							/#{분양정보pdf}/g,
							this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
						)
						if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
							element.linkMo = element.linkMo.replace(
								/#{청약안내pdf}/g,
								this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
							)
							element.linkPc = element.linkPc.replace(
								/#{청약안내pdf}/g,
								this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
							)
						}
						element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
						element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
						element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
						element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
					}
				})
				this.messageData2.button = JSON.stringify(buttonsData)
			}
			const data = {
				// 필수값

				code: this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE,
				sender: this.reservedaysData.callerNumber ? this.reservedaysData.callerNumber : process.env.VUE_APP_SENDER,
				senderkey: process.env.VUE_APP_SENDERKEY,
				tpl_code: this.messageData2.tplCode,
				receiver_1: this.$store.state.reserveusersData.phone,
				subject_1: this.messageData2.tplCodeStr,
				message_1: this.messageData2.message,
				recvname_1: this.$store.state.reserveusersData.name,
				failover: 'Y',
				fsubject_1: this.messageData2.tplCodeStr,
				fmessage_1: this.messageData2.message,
				button_1: this.messageData2.button ? this.messageData2.button : '[]',
				pay: this.reservedaysData.business?.id,
			}
			this.$store
				.dispatch('createSendMessage', data)
				.then(() => {})
				.catch(() => {})
		},

		messages() {
			const data = {}
			this.$store
				.dispatch('messages', data)
				.then(res => {
					// create / update 알림톡 tplCode messages 에서 찾기 -> reserveday tplCode 에서 index 0
					let foundIndex1 = res.data.messages.findIndex(obj => {
						return obj.tplCode === this.$store.state.reservedayData.tplCode[0]
					})
					// delete 알림톡 tplCode messages 에서 찾기 -> reserveday tplCode 에서 index 2
					let foundIndex2 = res.data.messages.findIndex(obj => {
						return obj.tplCode === this.$store.state.reservedayData.tplCode[2]
					})
					let foundIndex3 = res.data.messages.findIndex(obj => {
						return obj.tplCode === this.$store.state.reservedayData.tplCode[3]
					})
					let foundIndex4 = res.data.messages.findIndex(obj => {
						return obj.tplCode === this.$store.state.reservedayData.tplCode[12]
					})
					let foundIndex5 = res.data.messages.findIndex(obj => {
						return obj.tplCode === this.$store.state.reservedayData.tplCode[13]
					})
					let foundIndex6 = res.data.messages.findIndex(obj => {
						return obj.tplCode === this.$store.state.reservedayData.tplCode[14]
					})
					if (foundIndex1 !== -1) {
						this.messageData1 = res.data.messages[foundIndex1] // 생성 / 수정
					}
					if (foundIndex2 !== -1) {
						this.messageData2 = res.data.messages[foundIndex2] // delete 알림톡 데이터
					}
					if (foundIndex3 !== -1) {
						this.messageData3 = res.data.messages[foundIndex3] // delete 알림톡 데이터
					}
					if (foundIndex4 !== -1) {
						this.messageData4 = res.data.messages[foundIndex4] // 내가 받을 알림톡 알림톡 데이터
					}
					if (foundIndex5 !== -1) {
						this.messageData5 = res.data.messages[foundIndex5] // 내가 받을 알림톡 알림톡 데이터
					}
					if (foundIndex6 !== -1) {
						this.messageData6 = res.data.messages[foundIndex6] // 현장 방문등록
					}
				})
				.catch(() => {})
		},
		closeStep() {
			this.resetData()
			this.setdialog.dialog = false
		},
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		clickdoneBtn(type) {
			this.resetData()
			if (this.$route.name === 'reservedirect' && type === 'push') {
				this.$router.push({
					name: 'createwaiting',
					params: {
						code: this.$route.params.code,
						phone: this.$store.state.reserveusersData.phone,
					},
				})
			} else {
				if (this.$store.state.reservedayData.endLink) {
					window.open(this.$store.state.reservedayData.endLink, '_blank')
					if (this.$store.state.reservedayData.endLink.indexOf('kakao') > -1) {
						if (this.isMobile() !== 'desktop') {
							location.href = 'kakaotalk://inappbrowser/close'
						}
					}
				} else {
					window.open('about:blank', '_self').close()
					if (this.isMobile() !== 'desktop') {
						location.href = 'kakaotalk://inappbrowser/close'
					}
				}
			}
		},
		surveyDone() {
			this.resetData()
			this.setdialog.dialog = false
			if (this.$store.state.reservedayData.endLink) {
				window.open(this.$store.state.reservedayData.endLink, '_blank')
			} else {
				window.open('about:blank', '_self').close()
				if (this.isMobile() !== 'desktop') {
					location.href = 'kakaotalk://inappbrowser/close'
				}
			}
			this.step1 = true
		},
		nowTime() {
			/// 현재시간
			let a = new Date()
			let b = this.$moment(a).format('YYYY년 MM월 DD일')
			let c = this.$moment(a).format('hh:mm')
			var nowHour = a.getHours()
			let jeonhoo = ''
			if (nowHour < 12 && nowHour >= 0) {
				jeonhoo = ' 오전 '
			} else {
				jeonhoo = ' 오후 '
			} //12시 이전일 때 오전, 나머지 오후
			return b + jeonhoo + c
		},
		toDatePicker() {
			this.$store.state.loading = true
			if (this.$route.name !== 'reservedirect' && this.$route.name !== 'reserveday') {
				// 거주지(거주지역) 항목은 선택값이 obj.value가 아닌 searchsel_city에 저장되므로 필수값 검증에서 제외
				const isLocationItem = obj => {
					if (!obj) return false
					if (typeof obj.tag === 'string' && obj.tag.toLowerCase().indexOf('location') !== -1) return true
					if (typeof obj.contents === 'string' && obj.contents.indexOf('거주지역') !== -1) return true
					return false
				}
				const foundRadio = this.$store.state.reservedayInputBox.categories.findIndex(obj => {
					return obj.type === 10 && !isLocationItem(obj) && obj.value === '' && obj.musthave
				})
				const foundCheck = this.$store.state.reservedayInputBox.categories.findIndex(obj => {
					return (
						obj.type === 11 &&
						!isLocationItem(obj) &&
						obj.items.filter(x => x.value === null || x.value === '').length === obj.items.length &&
						obj.musthave
					)
				})

				const foundTextFiled = this.$store.state.reservedayInputBox.categories.findIndex(obj => {
					return obj.type === 20 && !isLocationItem(obj) && !obj.items.value && obj.musthave
				})
				// const foundFile = this.$store.state.reservedayInputBox.categories.findIndex(obj => {
				// 	return obj.type === 21 && this.$store.state.filesData.length > 0 && obj.musthave
				// })
				let noneValue = []
				if (foundTextFiled !== -1) {
					noneValue.push(foundTextFiled)
				}
				if (foundRadio !== -1) {
					noneValue.push(foundRadio)
				}
				if (foundCheck !== -1) {
					noneValue.push(foundCheck)
				}
				// if (foundFile !== -1) {
				// 	noneValue.push(foundFile)
				// }
				if (noneValue.length !== 0) {
					let min = Math.min.apply(Math, noneValue)
					this.$store.state.loading = false
					return document.querySelector(`#viewportItem${min}`).scrollIntoView({ block: 'start', behavior: 'smooth' })
				}
			}
			// 날짜 선택 화면으로 넘어가기 전 전체 예약 마감 여부 체크
			const rangeData = {
				sdate: this.$moment(this.reservedaysData.sdate).format('YYYY-MM-DD'),
				edate: this.$moment(this.reservedaysData.edate).format('YYYY-MM-DD'),
				status: 1,
				code: this.$route.params.code,
			}
			this.$store
				.dispatch('reserveusersRangeCount', rangeData)
				.then(res => {
					let index = res.data.reserveusersRangeCount.count.items.findIndex(e => e.List === this.reservedaysData.title)
					let sum = res.data.reserveusersRangeCount.count.items[index].Sum
					if (this.reservedaysData.totalMaxcount && sum >= this.reservedaysData.totalMaxcount) {
						this.$store.state.loading = false
						this.alertModal2.text = '전체 예약 인원이 마감되었습니다.'
						this.alertModal2.dialog = true
						return
					}
					this.$store.state.selectedTime = ''
					this.$store.state.selectedTimeDetail = ''
					this.step1 = false
					this.$store.state.loading = false
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},
		maxCountCheck(type) {
			if (this.isSubmitting) return
			this.isSubmitting = true
			this.messages()
			if (this.$route.name === 'reserveday' || this.$route.name === 'visitUploadModal' || this.$route.name === 'changeReserve') {
				this.maxcount2(type)
			} else {
				this.reserveusersRangeCount(type)
			}
		},
		filesUpload() {
			if (Object.keys(this.$store.state.filesData).length > 0) {
				let fileNumber = 0
				this.imgFiles = []
				for (let index = 0; index < Object.keys(this.$store.state.filesData).length; index++) {
					const el = this.$store.state.filesData[Number(Object.keys(this.$store.state.filesData)[index])]
					fileNumber += el.length
					if (index === Object.keys(this.$store.state.filesData).length - 1) {
						let imgIds = []
						for (let index = 0; index < this.$store.state.reservedayInputBox.categories.length; index++) {
							const elInput = this.$store.state.reservedayInputBox.categories[index]
							elInput.value = []
							if (elInput.type === 21) {
								if (this.$store.state.filesData[index]) {
									this.$store.state.filesData[index].forEach((el, filesIndex) => {
										this.$store.dispatch('upload', { file: el }).then(res => {
											this.imgFiles.push(res.data[0])
											imgIds.push(res.data[0].id)
											elInput.value.push(res.data[0])
										})
										if (Number(Object.keys(this.$store.state.filesData)[Object.keys(this.$store.state.filesData).length - 1]) === index) {
											if (filesIndex === this.$store.state.filesData[index].length - 1) {
												const upload = setInterval(() => {
													if (this.imgFiles.length === fileNumber) {
														this.$store.state.loading = false
														this.$store.commit('filesData', {})

														this.updateReserveuser(imgIds)
														clearInterval(upload)
													}
												}, 1000)
											}
										}
									})
								}
							}
						}
					}
				}
			} else {
				let imgIds = []

				this.updateReserveuser(imgIds)
			}
		},
		updateReserveuser(imgIds) {
			this.$store.state.reserveusersData.fileUpload
				.map(x => x.id)
				.forEach(element => {
					imgIds.push(element)
				})

			// 설문 데이터 맵핑

			let checkbox = []
			let checkone = [] // 라디오박스, 셀렉트박스 같이
			let radioEtc = [] // 라디오박스 etc 값
			let textfield = []

			// const date = new Date(String(`${this.$store.state.picker.date}, ${this.$store.state.selectedTime}`)) // 선택한 날짜, 시간
			// const serverDate = new Date(date.setHours(date.getHours() + 9)) // 서버용으로 시간 +9hour
			// 브라우저 타임존과 무관하게 한국시간(KST) 기준으로 rdate 생성 (관리자 레포와 동일 방식)
			const serverDate = new Date(`${this.$store.state.picker.date}T${this.$store.state.selectedTime}:00.000Z`)
			const bigCodes = this.$store.state.reservedayInputBox.categories.map(m => m.code).join(',')
			this.$store.state.reservedayInputBox.categories.forEach(obj => {
				if (obj.type === 10) {
					// 라디오버튼 value
					checkone.push(String(`${obj.code}:${obj.value}`))
					// 라디오 버튼 etc 값 저장
					if (obj.ect !== '') {
						radioEtc.push(String(`${obj.value}:${obj.etc}`))
					}
				} else if (obj.type === 11) {
					// 체크박스 value
					checkbox.push(String(`${obj.code}:${obj.items.map(x => x.value).join(',')}`))
				} else if (obj.type === 12) {
					// 셀렉트박스 value
					let valueIndex = obj.category_details.findIndex(x => x.detailname === obj.items.value)
					checkone.push(String(`${obj.code}:${obj.category_details[valueIndex].detailcode}`))
				} else if (obj.type === 20) {
					// 텍스트필드 value
					textfield.push(String(`${obj.code}:${obj.items.value}`))
				}
			})
			let companion = null
			this.$store.state.reservedayInputBox.categories.forEach(obj => {
				if (obj.tag === 'companion') {
					if (obj.category_details.length > 0 && obj.value) {
						companion = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
					}
				}
			})

			const data = {
				// ip: '', 추후 추가 예정?
				id: this.$store.state.reserveuserId,
				inputBoxTitle: this.$store.state.reservedayInputBox.name,
				inputBoxId: this.$store.state.reservedayInputBox.id,

				rdate: serverDate,
				bigCodes: bigCodes,
				companion: companion ? companion : 1,
				checkbox: checkbox.join('/'),
				checkone: checkone.join('/'),
				textfiled: textfield.join('/'),
				etc: radioEtc.join('/'), // radiobox 기타 값 맵핑
				title: this.title,
				fileUpload: imgIds,
				locationData:
					this.$store.state.reservedayInputBox.categories.map(x => x.type).indexOf(20) > -1
						? this.$store.state.searchsel_city1.value +
						  '_' +
						  this.$store.state.searchsel_city2.value +
						  '_' +
						  this.$store.state.searchsel_city3.value
						: '',
			}
			this.$store
				.dispatch('updateReserveuser', data)
				.then(res => {
					this.$store.state.loading = false
					this.isSubmitting = false
					this.$store.state.reserveUserData = {
						reserveUpdateDate: res.data.updateReserveuser.reserveuser.updated_at,
						name: res.data.updateReserveuser.reserveuser.name,
						reservedDate: res.data.updateReserveuser.reserveuser.rdate,
					}
					this.creaetSendMessage() // 예약 등록 시 메세지 발송
					this.setdialog.step1 = false
					this.setdialog.step3 = true
					this.step1 = true
				})
				.catch(err => {
					console.log(err)
					this.$store.state.loading = false
					this.isSubmitting = false
					alert('오류가 발생하였습니다. 새로 고침후 다시 시도해 주세요.')
				})
		},

		//예약 취소
		clickreseveCancel() {
			this.messages()
			const data = {
				id: this.$store.state.reserveuserId,

				status: 2,
			}
			this.$store
				.dispatch('updateReserveuser', data)
				.then(() => {
					this.setdialog.dialog = false
					this.alertModal2.text = '예약이 취소되었습니다.'
					this.alertModal2.dialog = true
					this.$store.commit('reserveuserId', '')
					this.setdialog.step1 = true
					this.setdialog.step2 = false
					this.setdialog.step3 = false
					this.step1 = true
					this.resetData()
					this.deleteSendMessage()
					this.$store.state.loading = false
					document.getElementById('refresh-visit').click()
				})
				.catch(() => {})
		},
		/// 예약 변경
		clickChangeBtn(re) {
			if (this.$store.state.reserveusersData) {
				if (this.$store.state.reserveusersData.code) {
					this.$store.state.loading = true
					this.$store.state.reservedayInputBox.categories.forEach(element => {
						if (element.tag === 'location') {
							if (this.$store.state.reserveusersData.locationData) {
								this.$store.state.searchsel_city1.value = this.$store.state.reserveusersData.locationData.split('_')[0]
								this.loc_firstSelect(this.$store.state.reserveusersData.locationData.split('_')[0])
								this.$store.state.searchsel_city2.value = this.$store.state.reserveusersData.locationData.split('_')[1]
								this.loc_twoSelect(this.$store.state.reserveusersData.locationData.split('_')[1])
								this.$store.state.searchsel_city3.value = this.$store.state.reserveusersData.locationData.split('_')[2]
							}
						} else if (element.type === 11) {
							this.$store.state.reserveusersData[this.changeTypeText(element.type)].split('/').forEach(type => {
								if (type.split(':')[0] === element.code) {
									type
										.split(':')[1]
										.split(',')
										.forEach((detailCode, index) => {
											element.items[index].value = detailCode
										})
								}
							})
						} else if (element.type === 10) {
							this.$store.state.reserveusersData[this.changeTypeText(element.type)].split('/').forEach(type => {
								if (type.split(':')[0] === element.code) {
									let index = element.category_details.findIndex(val => val.detailcode === type.split(':')[1])
									if (index >= 0) {
										if (element.category_details[index].detailname === '기타') {
											console.log(this.$store.state.reserveusersData)
											let etc = this.$store.state.reserveusersData.etc.split('/')
											let etcIndex = etc.findIndex(e => e.indexOf(type.split(':')[1]) !== -1)
											element.etc = etc[etcIndex].split(':')[1]
										}
										this.$store.state.nowRadioValue.push(type.split(':')[1])
										element.value = type.split(':')[1]
									}
								}
							})
						} else if (element.type === 12) {
							this.$store.state.reserveusersData[this.changeTypeText(element.type)].split('/').forEach(type => {
								if (type.split(':')[0] === element.code) {
									let index = element.category_details.findIndex(val => val.detailcode === type.split(':')[1])
									element.items.value = element.category_details[index].detailname
								}
							})
						} else if (element.type === 20) {
							this.$store.state.reserveusersData[this.changeTypeText(element.type)].split('/').forEach(type => {
								if (type.split(':')[0] === element.code) {
									element.items.value = type.split(':')[1]
								}
							})
						}
					})
					if (this.$store.state.reserveusersData.ismarketing === 1 && this.$store.state.reserveusersData.ispersonal === 1) {
						this.$store.state.check1.value = true
						this.$store.state.check2.value = true
						this.$store.state.check3.value = true
					} else {
						this.$store.state.check4.value = true
					}
					// this.$store.state.selectedTime = this.$store.state.reserveusersData.rdate.substring(11, 16)
					// this.$store.state.picker = {
					// 	date: this.$store.state.reserveusersData.rdate.substring(0, 10),
					// }
					const setData = this.$store.state.reservedayInputBox
					this.$store.commit('reservedayInputBox', {})
					setTimeout(() => {
						this.$store.state.loading = false
						this.$store.commit('reservedayInputBox', setData)
					}, 500)
					if (re !== 're') {
						this.reserveChangeOn = true
						this.setdialog.step1 = true
						this.setdialog.step2 = false
						this.setdialog.step3 = false
						this.step1 = true
						this.$store.state.selectedTime = ''
						this.$store.state.selectedTimeDetail = ''
					}
					this.$store.state.picker.date = ''
				} else {
					this.$store.state.loading = false
					this.alertModal2.dialog = true
					this.alertModal2.text = '현 시각 기준으로 방문일시가 이전이면 변경이 불가능 합니다.'
				}
			} else {
				this.$store.state.loading = false
				this.alertModal2.dialog = true
				this.alertModal2.text = '현 시각 기준으로 방문일시가 이전이면 변경이 불가능 합니다.'
			}
		},
		resetData() {
			this.$store.state.reservedayInputBox.categories.forEach(obj => {
				if (obj.type === 10) {
					obj.value = ''
					obj.etc = ''
					this.$store.state.nowRadioValue = []
				} else if (obj.type === 11) {
					obj.items.forEach(item => {
						item.value = ''
					})
				} else if (obj.type === 12 || obj.type === 20) {
					obj.items.value = ''
				}
			})
			this.$store.state.picker.date = ''
			this.$store.state.selectedTime = ''
			this.$store.state.check1.value = false
			this.$store.state.check2.value = false
			this.$store.state.check3.value = false
			this.$store.state.check4.value = false
			this.$store.state.check5.value = false
			this.$store.state.check6.value = false
			this.reserveChangeOn = false
		},
		checkWaitings(data) {
			const data1 = {
				code: this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE,
				// stat: 0,
				csdate: this.$moment().format('YYYY-MM-DD') + 'T00:00:00.000Z',
				cedate:
					this.$moment()
						.add(1, 'days')
						.format('YYYY-MM-DD') + 'T00:00:00.000Z',
				// seat: 0,
			}
			this.$store
				.dispatch('simpleWaitings', data1)
				.then(res => {
					// const check = res.data.waitings.map(x => x.phone).indexOf(this.greetingNum)
					const waitingsPeople = res.data.waitings.filter(x => {
						return x.stat === 0
					})
					this.waitLength = waitingsPeople.length
					let sorted = res.data.waitings.sort((a, b) => {
						if (a.waitingnum > b.waitingnum) return -1
						if (a.waitingnum === b.waitingnum) return 0
						if (a.waitingnum < b.waitingnum) return 1
					})
					if (sorted.length === 0) {
						if (this.reservedaysData.startWaitingNumber) {
							this.waitNum = this.reservedaysData.startWaitingNumber
						} else {
							this.waitNum = 0
						}
					} else {
						this.waitNum = sorted[0].waitingnum
					}
					// if (check === -1) {
					if (this.$route.name === 'createwaiting') {
						if (this.$route.params.phone === data.phone) {
							this.createWaiting(data)
						}
					} else {
						if (this.recentPhone !== data.phone) {
							this.createWaiting(data)
						}
					}
					// }
					this.setdialog.step1 = false
					this.setdialog.step2 = true
					this.step1 = true
				})
				.catch(() => {})
		},
		createWaiting(data) {
			let filesId = []
			if (data.fileUpload.length > 0) {
				filesId = data.fileUpload
			}
			this.messages()
			this.recentPhone = data.phone
			const datas = {
				inputBoxTitle: data.inputBoxTitle,
				tracking_code: data.tracking_code,
				name: data.name,
				phone: data.phone,

				code: this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE,
				ismarketing: data.ismarketing,
				ispersonal: 1,
				cdate: this.$moment(new Date()).add(9, 'hour'),
				date: data.date,
				bigCodes: data.bigCodes,
				checkbox: data.checkbox,
				checkone: data.checkone,
				etc: data.etc,
				textfiled: data.textfiled,
				waitingnum: this.waitNum + 1,
				stat: 0,
				rdate: data.rdate,
				title: data.title,
				seat: 0, // 상담석으로 가기전의 대기 상태 부여 => seat = 0
				fileUpload: filesId,
				marketing: this.$store.state.check5.value,
				receiveInformation: this.$store.state.check6.value,
				business: Number(this.reservedaysData.business.id),
			}
			this.$store
				.dispatch('createWaiting', datas)
				.then(res => {
					this.waitNum = this.waitNum + 1
					this.$store.state.loading = false
					this.isSubmitting = false
					this.sendMessageForDirect(res.data.createWaiting.waiting)
					// this.$socket.emit('reservation', { code: datas.code })
					// this.$socket.emit('reservationBoardList', { code: datas.code })
				})
				.catch(err => {
					this.$store.state.loading = false
					this.isSubmitting = false
					console.log({ err })
				})
		},
		sendMessageForDirect(userdata) {
			const rdate = this.$moment(userdata.rdate)
				.subtract('hours', 9)
				.format('YYYY년 MM월 DD일 HH:mm')
			let url = `${location.protocol}//${location.hostname}/waitingCheck/${this.$route.params.code}/${this.$store.state.reserveusersData.phone}`
			if (this.messageData3.message === undefined) {
				// 생성 / 수정시 알림톡 tpl_code가 없는 경우
				return
			} else {
				this.messageData3.message = this.messageData3.message.replace(/#{사업지명}/g, this.$store.state.reservedayData.title)
				this.messageData3.message = this.messageData3.message.replace(/#{고객명}/g, this.$store.state.reserveusersData.name)
				this.messageData3.message = this.messageData3.message.replace(/#{상담신청일시}/g, rdate)
				this.messageData3.message = this.messageData3.message.replace(/#{관람신청일시}/g, rdate)
				this.messageData3.message = this.messageData3.message.replace(/#{대기번호}/g, userdata.waitingnum)
				this.messageData3.message = this.messageData3.message.replace(/#{대기번호1}/g, userdata.waitingnum)
				this.messageData3.message = this.messageData3.message.replace(/#{대기번호2}/g, userdata.waitingnum)
				this.messageData3.message = this.messageData3.message.replace(/#{대기자수}/g, this.waitLength)
				this.messageData3.message = this.messageData3.message.replace(/#{대기정보}/g, url)
				this.messageData3.message = this.messageData3.message.replace(/#{대표번호}/g, this.$store.state.reservedayData.callerNumber)
			}
			const buttonsData = JSON.parse(this.messageData3.button)
			buttonsData.forEach(element => {
				element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
				element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
				element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
				element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
				element.linkMo = element.linkMo.replace(/#{전화번호}/g, this.$store.state.reserveusersData.phone)
				element.linkPc = element.linkPc.replace(/#{전화번호}/g, this.$store.state.reserveusersData.phone)
				element.linkMo = element.linkMo.replace(/#{상담ID}/g, this.$route.params.id)
				element.linkPc = element.linkPc.replace(/#{상담ID}/g, this.$route.params.id)
				element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.$route.params.id)
				element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.$route.params.id)
				element.linkMo = element.linkMo.replace(
					/#{분양정보pdf}/g,
					this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
				)
				element.linkPc = element.linkPc.replace(
					/#{분양정보pdf}/g,
					this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
				)
				if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
					element.linkMo = element.linkMo.replace(
						/#{청약안내pdf}/g,
						this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
					)
					element.linkPc = element.linkPc.replace(
						/#{청약안내pdf}/g,
						this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
					)
				}
				element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
				element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
				element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
				element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
			})
			this.messageData3.button = JSON.stringify(buttonsData)
			const data = {
				// 필수값

				code: this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE,
				sender: this.reservedaysData.callerNumber ? this.reservedaysData.callerNumber : process.env.VUE_APP_SENDER,
				senderkey: process.env.VUE_APP_SENDERKEY,
				tpl_code: this.messageData3.tplCode,
				receiver_1: this.$store.state.reserveusersData.phone,
				subject_1: this.messageData3.tplCodeStr,
				message_1: this.messageData3.message,
				// 여기까지 필수값
				// apikey: this.$store.state.apikey,
				// userid: this.$store.state.userid,
				recvname_1: this.$store.state.reserveusersData.name,
				failover: 'Y',
				fsubject_1: this.messageData3.tplCodeStr,
				fmessage_1: this.messageData3.message,
				button_1: this.messageData3.button ? this.messageData3.button : '[]',
				pay: this.reservedaysData.business?.id,
			}
			this.$store.dispatch('createSendMessage', data).then(() => {})
		},
		maxcount2(type) {
			const date = String(`${this.$store.state.picker.date}T00:00:00.000Z`)
			const data = {
				code: this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE,
				date: date,
			}

			this.$store
				.dispatch('reservedayMaxCount2', data)
				.then(res => {
					let dateIndex = this.reservedaysData.nodaySetting.findIndex(e => e.date === this.$store.state.picker.date)
					let selcetNodayset = this.reservedaysData.nodaySetting[dateIndex]
					let resCount = res.data.reservedayMaxCount2.count
					let time = this.$store.state.selectedTimeDetail
					if (time.split(':')[0] === '08' || time.split(':')[0] === '09') {
						time = time.substr(1)
					}
					let selectIndex = selcetNodayset.times.findIndex(e => e.clock === this.$store.state.selectedTimeDetail)
					let selectNoday = selcetNodayset.times[selectIndex]
					let resCountIndex = resCount.findIndex(obj => Object.keys(obj)[0] === time)

					if (resCount[resCountIndex][time] >= selectNoday.maxCount) {
						this.$store.state.loading = false
						this.isSubmitting = false
						this.alertModal2.text = '선택하신 시간의 최대 예약 인원수가 초과 되었습니다.'
						this.alertModal2.dialog = true
					} else {
						if (type === 'create') {
							this.reserveusersRangeCount(type)
						} else {
							this.reserveusersRangeCount(type)
						}
					}
				})
				.catch(() => {
					this.$store.state.loading = false
					this.isSubmitting = false
				})
		},
		reserveusersRangeCount(type) {
			const data = {
				sdate: this.$moment(this.reservedaysData.sdate).format('YYYY-MM-DD'),
				edate: this.$moment(this.reservedaysData.edate).format('YYYY-MM-DD'),
				status: 1,
				code: this.$route.params.code,
			}
			this.$store
				.dispatch('reserveusersRangeCount', data)
				.then(res => {
					let index = res.data.reserveusersRangeCount.count.items.findIndex(e => e.List === this.reservedaysData.title)
					let sum = res.data.reserveusersRangeCount.count.items[index].Sum
					// 전체 최대 예약 인원 초과 시 차단
					if (this.reservedaysData.totalMaxcount && sum >= this.reservedaysData.totalMaxcount) {
						this.$store.state.loading = false
						this.isSubmitting = false
						this.alertModal2.text = '전체 예약 인원이 마감되었습니다.'
						this.alertModal2.dialog = true
						return
					}
					let half = Math.floor(this.reservedaysData.totalMaxcount / 2)
					let eighty = Math.floor((this.reservedaysData.totalMaxcount / 100) * 80)
					if (sum + 1 === half) {
						this.percent = 50
					} else if (sum + 1 === eighty) {
						this.percent = 80
					} else if (sum + 1 === this.reservedaysData.totalMaxcount) {
						this.percent = 100
					}
					setTimeout(() => {
						this.percent = ''
					}, 2000)
					this.filesUpload(type)
				})
				.catch(() => {
					this.$store.state.loading = false
					this.isSubmitting = false
				})
		},
		exitSurvey() {
			this.setdialog.dialog = false
			setTimeout(() => {
				this.setdialog.step1 = true
				this.setdialog.step2 = false
				this.step1 = true
			}, 500)
		},
		clickCancel() {
			this.clickreseveCancel()
		},
	},
}
</script>

<style lang="scss">
.vieport_headTxt {
	width: 100%;
	max-width: 320px;
	margin: 31px 0px 17px;
	color: #636363;
	font-size: 16px;
	font-weight: bold;
}
.reservedayViewport {
	max-height: 84% !important;
	// overflow: hidden !important;
	overflow: auto;
}

.dialogDays {
	.title {
		height: 60px;
		display: flex;
		align-items: center;
		background-color: #fdc85a;
		padding: 0 25px;

		h2 {
			color: white;
		}

		.title-icon {
			color: white;
		}
	}

	.dialog-content {
		padding: 10px;
		.divider-dark {
			background-color: black;
		}

		.dialog-left {
			max-width: 200px;
			padding: 20px 25px;
			text-align: right;

			.dialog-star {
				color: red;
				margin-left: 8px;
				width: 8px;
			}
		}

		.dialog-right {
			padding: 20px 25px;
		}
	}
	.dialog-content1 {
		padding: 16px;
		.infoCard {
			padding: 16px;
			box-shadow: 0px 18px 11px 4px lightgrey;
			.infoBackground {
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 50%;
				min-width: 90px;
				min-height: 90px;
				margin-bottom: 10px;
				.infoYear {
					background-color: white;
					color: black;
					font-size: 14px;
					border-radius: 10px 10px 0px 0px;
				}
				.infoHour {
					font-size: 14px;
					font-weight: 100;
				}
			}
			.infoText {
				display: flex;
				margin-top: 12px;
				font-size: 16px;
				font-weight: 500;
				color: #656565;
				.infoTextValue {
					margin-left: auto;
				}
			}
		}
		.springNote {
			height: 20px;
			background: radial-gradient(ellipse at bottom, transparent 53%, white 53%);
			background-size: 33px 40px;
			margin-bottom: 25px;
		}
	}
	.bottom {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}
	.bottom2 {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}
}

.dateGuideDay {
	font-size: 80%;
	font-weight: bold;
}
.contentName {
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 5px !important;
}
.v-btn--rounded {
	border-radius: 0;
}
.smallLabel {
	margin-top: 5px;
	.v-label {
		font-size: 14px !important;
		color: #a6a6a6 !important;
	}
}
.allAgree {
	margin-top: 5px;
	.v-label {
		font-size: 14px;
		font-weight: bold;
		color: #a6a6a6 !important;
	}
}
.layout {
	margin: 0px 0px 0px 0px !important;
}
.resCheck {
	font-size: 14px;
	font-weight: bold;
}
.infoCheck {
	color: #2a3c48;
	font-weight: bold;
	font-size: 16px;
	span {
		color: white;
		background-color: #2a3c48;
		padding: 5px 10px 5px 10px;
		font-size: 12px;
		border-radius: 5px;
		margin-right: 7px;
	}
}
.lastInfo {
	font-size: 14px;
	color: #4b4948;
	margin-bottom: 0px !important;
}
.place-title-strong {
	font-weight: bold !important;
	color: #006b8f;
}
.surveyNameres {
	text-align: center;
	font-size: 17px;
	font-weight: bold;
	margin: 16px 0px !important;
}
.resinfoCheck {
	color: #2a3c48;
	font-weight: 500;
	font-size: 14px;
	span {
		color: white;
		background-color: #2a3c48;
		padding: 5px 10px 5px 10px;
		font-size: 12px;
		border-radius: 5px;
		margin-right: 7px;
	}
}
.lastInfoRes {
	white-space: pre-line;
	font-size: 15px;
	font-weight: 500;
	color: #656565;
	margin-bottom: 0px !important;
}
</style>
